import React from 'react'
import CheckIcon from '../images/check.svg'
import classNames from 'classnames'
import request from 'superagent'
import parse from 'url-parse'
import ym from 'react-yandex-metrika'
import { OnlinepbxModalMessage } from '@onpbx/onlinepbx-components'
import { AmplitudeCounter } from "~/amplitude-counter";
import {useAppSelector} from "~/hooks/redux";

interface IForm {
  isWhite?: boolean;
  children?: React.ReactNode;
  text: string;
  free?: boolean;
  isRedirect?: boolean;
  pageName?: string;
  formType?: string;
  onSubmit?: Function;
}

export const Form: React.FC<IForm> = ({ isWhite, pageName = '', isRedirect = true, children, text, free, formType = 'service', onSubmit }) => {
  const { country } = useAppSelector(state => state.countryReducer);
  const [error, setError] = React.useState<string>('')
  const [value, setValue] = React.useState<string>('')
  const [isShowSuccessMessage, setIsShowSuccessMessage] = React.useState(false)
  const isPartner = (process.env.IS_BROWSER + '') === 'true' && window.location.pathname === '/partners'
  const reg = /[^0-9+()]/g

  React.useEffect(() => {
    const href = parse(window.location.href, true)
    const utmCampaign = href.query.utm_campaign || ''
    const utmContent = href.query.utm_content || ''
    const utmMedium = href.query.utm_medium || ''
    const utmSource = href.query.utm_source || ''
    const utmTerm = href.query.utm_term || ''
    const rawPartnerId = href.query.partnerId || ''
    const hasPartnerId = !!rawPartnerId && !isNaN(+rawPartnerId.charAt(0))
    const partnerId = hasPartnerId ? Number.parseInt(rawPartnerId) + '' : ''
    const promo = href.query.promo || ''
    let preHostname = window.location.hostname.split('.').slice(1).join('.')
    if (preHostname) {
      preHostname = '.' + preHostname
    }
    const hostname = preHostname || window.location.hostname

    utmCampaign && !document.cookie.includes(`utm_campaign=${utmCampaign};`) &&
      (document.cookie = 'utm_campaign=' + utmCampaign + '; ' + 'Max-Age=100000' + '; ' +  'Domain=' + hostname + '; ' + document.cookie)
    utmContent && !document.cookie.includes(`utm_content=${utmContent};`) &&
      (document.cookie = 'utm_content=' + utmContent + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
    utmMedium && !document.cookie.includes(`utm_medium=${utmMedium};`) &&
      (document.cookie = 'utm_medium=' + utmMedium + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
    utmSource && !document.cookie.includes(`utm_source=${utmSource};`) &&
      (document.cookie = 'utm_source=' + utmSource + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
    utmTerm && !document.cookie.includes(`utm_term=${utmTerm};`) &&
      (document.cookie = 'utm_term=' + utmTerm + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
    partnerId && !document.cookie.includes(`partnerId=${partnerId};`) &&
      (document.cookie = 'partnerId=' + partnerId + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
    promo && !document.cookie.includes(`promo=${promo};`) && (document.cookie = 'promo=' + promo + '; ' + 'Max-Age=100000' + '; ' + document.cookie) &&
      (document.cookie = 'promo=' + promo + '; ' + 'Max-Age=100000' + '; ' + 'Domain=' + hostname + '; ' + document.cookie)
  })

  const getLink = () => {
    switch (process.env.SERVER_NODE_ENV) {
      case 'production':
        if (isPartner) return 'https://partners.onlinepbx.ru'
        return 'https://panel.onlinepbx.ru'
      case 'development':
        if (isPartner) return 'https://partners.test.onlinepbx.ru'
        return 'https://panel.test.onlinepbx.ru'
      case 'stage':
        if (isPartner) return 'https://partners.stage.onlinepbx.ru'
        return 'https://panel.stage.onlinepbx.ru'
    }
  }

  const handleChange = (evt: React.ChangeEvent<HTMLInputElement>) => {
    if (!!error) {
      setError('')
    }
    setValue(evt.target.value.replace(reg, ''))
  }

  const getMetriks = (): object => {
    const gaUid = document.cookie.replace(/(?:(?:^|.*;\s*)_gid\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const ymUid = document.cookie.replace(/(?:(?:^|.*;\s*)_ym_uid\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const roistatVisit = document.cookie.replace(/(?:(?:^|.*;\s*)roistat_visit\s*=\s*([^;]*).*$)|^.*$/, '$1')
    return {
      ga_uid: gaUid,
      ym_uid: ymUid,
      roistat_visit: roistatVisit
    }

  }

  const getUtms = (): any => {
    const utmMedium = document.cookie.replace(/(?:(?:^|.*;\s*)utm_medium\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmSource = document.cookie.replace(/(?:(?:^|.*;\s*)utm_source\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmCampaign = document.cookie.replace(/(?:(?:^|.*;\s*)utm_campaign\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmTerm = document.cookie.replace(/(?:(?:^|.*;\s*)utm_term\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const utmContent = document.cookie.replace(/(?:(?:^|.*;\s*)utm_content\s*=\s*([^;]*).*$)|^.*$/, '$1')
    return {
      utmMedium,
      utmSource,
      utmCampaign,
      utmTerm,
      utmContent
    }
  }

  const getPartnerId = (): any => {
    return document.cookie.replace(/(?:(?:^|.*;\s*)partnerId\s*=\s*([^;]*).*$)|^.*$/, '$1')
  }

  const preRegistration = async () => {
    const link = getLink()
    const href = (process.env.IS_BROWSER + '') === 'true' && window.location.href
    const partnerId = getPartnerId()
    const data = {
      register: href,
      phone: value,
      ...formType && { form: formType },
      ...(partnerId ? { partner_id: partnerId } : {}),
      ...getUtms(),
      ...getMetriks()
    }
    return await request
      .post(`${link}/api/register/pre-registration`)
      .set('Accept', 'application/json').send(data)
      .then(() => !isRedirect && setIsShowSuccessMessage(true))
  }

  const preRegistrationPartner = async () => {
    const link = getLink()
    const data = {
      phone: value,
      ...formType && { form: formType },
      ...getUtms(),
      ...getMetriks()
    }
    return await request.post(`${link}/api/register/before`).set('Accept', 'application/json').send(data)
  }


  const handleRedirect = () => {
    const utms = getUtms()
    const link = getLink()
    const partnerId = document.cookie.replace(/(?:(?:^|.*;\s*)partnerId\s*=\s*([^;]*).*$)|^.*$/, '$1')
    const promo = document.cookie.replace(/(?:(?:^|.*;\s*)promo\s*=\s*([^;]*).*$)|^.*$/, '$1')

    if (!value) {
      setError('Введите номер телефона.')
      setTimeout(() => setError(''), 3000)
      return
    }
    if (value && value.length < 10) {
      setError('Слишком короткий номер.')
      setTimeout(() => setError(''), 3000)
      return
    }
    AmplitudeCounter('click_registration', { 'name_button': text, 'page_name': pageName })
    AmplitudeCounter('click_registration', { 'country_site': country?.value.toLowerCase()})
    const query = Object.keys(utms).map(utm => {
      if (!utms[utm]) return
      return `${utm}=${utms[utm]}`
    }).filter(utm => utm).join('&')

    const url = new window.URL(`${link}/register/?${query}`)

    url.searchParams.append('phone', value)
    !!partnerId && url.searchParams.append('partnerId', partnerId)
    !!promo && url.searchParams.append('promo', promo)

    if (isPartner) {
      preRegistrationPartner()
      ym('reachGoal', 'partner-lead', { phone: value })
    } else {
      preRegistration()
      if (isRedirect) {
        ym('reachGoal', 'lead', { phone: value, url: window.location.href })
      } else {
        ym('reachGoal', 'get_consultation', {})
      }
    }

    onSubmit && onSubmit()

    !error && isRedirect && window.open(url.toString(), '_blank')
  }

  const handlePress = (evt: React.KeyboardEvent) => {
    if (evt.keyCode === 13) {
      handleRedirect()
    }
  }
  return (
    <>
      <div className='onlinepbx__form'>
        <div className='onlinepbx__form__field'>
          <input
            className={classNames('onlinepbx__form__input', {
              'onlinepbx__form__input__white': isWhite
            })}
            value={value}
            onChange={handleChange}
            onKeyUp={handlePress}
            placeholder='Контактный номер'
            type="text" />
          {error && <div className='onlinepbx__form__message'>
            {error}
          </div>}
        </div>
        <button
          onClick={handleRedirect}
          className='onlinepbx__form__button'>
          {text}
        </button>
        {
          isShowSuccessMessage &&
          <OnlinepbxModalMessage
            buttons
            isModal
            status='success'
            header={<span className='onlinepbx__form__modalmessage'>Мы получили Вашу заявку. Менеджер свяжется с Вами в ближайшее время.</span>}
            textButtonLink='Закрыть'
            onClickButtonLink={() => setIsShowSuccessMessage(false)}
          />
        }
      </div>
      {free && <div className='onlinepbx__form__free'>
        <CheckIcon className='onlinepbx__form__free__check' />
        <div className='onlinepbx__form__free__text'>
          7 дней бесплатно
        </div>
      </div> || children && <div className='onlinepbx__form__free'>{children}</div> || ''}
    </>
  )
}

export default Form
